<template>
  <el-dialog
    title="提出异议"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="异议原因" prop="objectionReason">
        <el-input
          v-model="form.objectionReason"
          type="textarea"
          :rows="4"
          placeholder="请输入异议原因"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="dialogVisible = false">{{ $t('common.btn.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.btn.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { submitObjection } from '@/api/provision/provisionData'

export default {
  name: 'ObjectionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        objectionReason: ''
      },
      rules: {
        objectionReason: [
          { required: true, message: '异议原因没有输入，无法提交', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()

        // 这里需要父组件传入选中的UUID列表
        // 简化处理，假设父组件会通过props传入
        const res = await submitObjection({
          uuids: this.$parent.selectedRows.map(row => row.uuid),
          objectionReason: this.form.objectionReason
        })

        if (res.ok) {
          this.dialogVisible = false
          this.$emit('success')
        }
      } catch (error) {
        console.error(error)
      }
    },

    handleClose() {
      this.$refs.formRef.resetFields()
      this.form = {
        objectionReason: ''
      }
    }
  }
}
</script>
